import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { tableItem } from './style'

class TableItem extends PureComponent {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.object).isRequired,
    item: PropTypes.object.isRequired,
    onClick: PropTypes.func
  }

  static defaultProps = {
    onClick: () => {}
  }

  onClick() {
    this.props.onClick(this.props.item)
  }

  render() {
    const { item, fields } = this.props

    return (
      <div
        className="table-item-container"
        onClick={() => {
          this.onClick()
        }}
      >
        {fields.map((field, index) => {
          const itemValue = item[field.key]
          const renderValue = field.render || (() => itemValue)

          return (
            <div
              key={`${this.key}-${index}`}
              className="table-item-field"
              style={{ width: field.width }}
            >
              {renderValue.apply(null, [item])}
            </div>
          )
        })}
        <style jsx>{tableItem}</style>
      </div>
    )
  }
}

export default TableItem
